import React from "react";
import Matches from "../../components/Matches";
export default function Index() {
  return (
    <div>
      <Matches />
    </div>
  );
}
